import mainCaller from './mainCaller';

// 지점의 출입문 목록. converted=false 면 아직 종목 기반 출입그룹 체계를 쓰는 지점.
export const listBranchDoors = async (branchId, token) =>
  mainCaller(`admin/api/v1/branch-doors?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });

// 출입문 신규 등록
export const createBranchDoor = async (payload, token) =>
  mainCaller(`admin/api/v1/branch-doors`, 'POST', payload, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

// 출입문 수정 (출입문명/메모/단말)
export const updateBranchDoor = async (id, payload, token) =>
  mainCaller(`admin/api/v1/branch-doors/${id}`, 'PUT', payload, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

// 출입 제한 토글
export const updateBranchDoorRestriction = async (id, restricted, token) =>
  mainCaller(`admin/api/v1/branch-doors/${id}/restriction`, 'PUT', { restricted }, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

// 문별 입장시간 조회 — custom=false면 지점 공통(입장시간→영업시간) 따름
export const getDoorEntranceTime = async (id, token) =>
  mainCaller(`admin/api/v1/branch-doors/${id}/entrance-time`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });

// 문별 입장시간 저장 — custom=false는 지점 공통 복귀. UBio 자동 동기화
export const saveDoorEntranceTime = async (id, payload, token) =>
  mainCaller(`admin/api/v1/branch-doors/${id}/entrance-time`, 'PUT', payload, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

// 종목 기반 출입그룹 체계를 출입문 체계로 전환 (되돌릴 수 없음)
export const convertBranchDoors = async (branchId, token) =>
  mainCaller(`admin/api/v1/branch-doors/convert?branchId=${branchId}`, 'POST', null, {
    Authorization: `Bearer ${token}`,
  });

// 출입문 삭제 — 출입권 보유 회원이 있으면 서버가 거부. UBio 그룹/구역 삭제, 단말 등록은 유지
export const deleteBranchDoor = async (id, token) =>
  mainCaller(`admin/api/v1/branch-doors/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
